var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStatus = function SvgStatus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "status_svg2__a",
    x1: 4.39,
    x2: 200.89,
    y1: 144.39,
    y2: 6.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#status_svg2__a",
    id: "status_svg2__b",
    x1: 32.59,
    x2: 229.09,
    y1: 184.56,
    y2: 46.59
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M100 0C44.78 0 0 44.78 0 100c0 2.06.09 4.09.21 6.12l54.52-.23L73.44 32.5c.89-3.5 4.11-5.86 7.79-5.55 3.6.3 6.46 3.16 6.77 6.76l7.53 89.97 12.66-59.77c.68-3.24 3.43-5.62 6.74-5.86 3.27-.22 6.35 1.76 7.47 4.87l15.54 43.01 61.82.75c.15-2.2.25-4.43.25-6.68C200 44.78 155.23 0 100 0",
    style: {
      fill: "url(#status_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m125.75 115.78-8.47-23.4-17.69 83.61a7.42 7.42 0 0 1-7.25 5.87c-.16 0-.31-.01-.47-.01a7.41 7.41 0 0 1-6.92-6.77L76.9 78.85l-9.24 36.24a7.41 7.41 0 0 1-7.16 5.58l-58.3.24c9.61 45.18 49.74 79.08 97.78 79.08s87.84-33.62 97.67-78.53l-65.04-.79a7.405 7.405 0 0 1-6.88-4.89Z",
    style: {
      fill: "url(#status_svg2__b)"
    }
  }));
};
export default SvgStatus;